<template>
    <div>
        <v-row v-if="listItem.length > 0">
            <v-col cols="12">
                <v-data-table
                        :headers="getHeaders"
                        :items="listItem"
                        :options.sync="options"
                        :items-per-page="options.rowsPerPageItems"
                        :server-items-length="total"
                        :footer-props="{'items-per-page-options': this.$store.state.rowsPerPageItems, 'items-per-page-text': $t('rowsPerPage')}"
                        :no-data-text="$t('noDataAvailable')"
                >
                    <template v-slot:item.typeCodeDescription="{ item }">
                        <div class="order-edit-modal-table__code-description"> {{item.typeCodeDescription}}</div>
                    </template>
                    <template v-slot:item.approved="{ item }">
                        <span v-if="item.approved === false">{{ $t('crm.no') }}</span>
                        <span v-if="item.approved === true">{{ $t('crm.yes') }}</span>
                    </template>
                    <template v-slot:item.edit="{ item }">
                        <v-btn fab small color="#fff">
                            <v-icon
                                    color="#5b8ff5"
                                    @click="editItem(item)"
                            >
                                mdi-pencil-outline
                            </v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:item.delete="{ item }">
                        <v-btn :disabled="isDisabledByStatus()" fab small color="#fff">
                            <v-icon
                                    color="#5b8ff5"
                                    @click="deleteItem(item.id)"
                            >
                                mdi-delete
                            </v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog v-if="tableType==='pallets'" v-model="dialogTable" max-width="600px">
            <v-card>
                <v-card-title class="headline lighten-2" primary-title>
                    {{ formTitlePallets }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-form ref="formPallets" v-model="formPalletsValid" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col class="pb-0" cols="12">
                                    <v-textarea
                                            v-model="payloadPallets.typeCodeDescription"
                                            :rules="[rules.required, rules.length(100)]"
                                            :label="$t('crm.description')"
                                            required
                                            outlined
                                            :disabled="isDisabled(this.payloadPallets.id)"
                                            counter="100"
                                    ></v-textarea>
                                </v-col>
                                <v-col class="pb-0" cols="12">
                                    <v-text-field
                                            v-model="payloadPallets.unitWeight"
                                            :rules="[rules.decimal]"
                                            :label="$t('crm.unitWeight')"
                                            outlined
                                            :disabled="isDisabled(this.payloadPallets.id)"
                                    ></v-text-field>
                                </v-col>
                                <v-row>
                                    <v-col cols="12">
                                        <label>{{$t('crm.pickupGoods')}}</label>
                                    </v-col>
                                    <v-col class="pb-0" cols="12" md="6">
                                        <v-text-field
                                                v-model="payloadPallets.loadingPlaceUnloaded"
                                                :rules="[rules.number]"
                                                :label="$t('crm.unloadGoods')"
                                                outlined
                                                :disabled="isDisabledByStatus()"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col class="pb-0" cols="12" md="6">
                                        <v-text-field
                                                v-model="payloadPallets.loadingPlaceLoaded"
                                                :rules="[rules.number]"
                                                :label="$t('crm.loadGoods')"
                                                outlined
                                                :disabled="isDisabledByStatus()"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <label>{{$t('crm.deliveryGoods')}}</label>
                                    </v-col>
                                    <v-col class="pb-0" cols="12" md="6">
                                        <v-text-field
                                                v-model="payloadPallets.unloadingPlaceUnloaded"
                                                :rules="[rules.number]"
                                                :label="$t('crm.unloadGoods')"
                                                outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col class="pb-0" cols="12" md="6">
                                        <v-text-field
                                                v-model="payloadPallets.unloadingPlaceLoaded"
                                                :rules="[rules.number]"
                                                :label="$t('crm.loadGoods')"
                                                outlined
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn right text color="primary" @click="() => closeDialog()">
                        {{ $t('cancel') }}
                    </v-btn>
                    <v-btn right text color="primary" @click="savePallet">
                        {{ $t('apply') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-if="tableType==='goods'" v-model="dialogTableGoods" max-width="600px">
            <v-card>
                <v-card-title class="headline lighten-2" primary-title>
                    {{ formTitleGoods }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-form ref="formGoods" v-model="formGoodsValid" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col v-if="editCrmId" class="pb-0" cols="12">
                                    <v-textarea
                                            v-model="payloadGoods.goodsNature"
                                            :rules="[rules.required, rules.length(200)]"
                                            :label="$t('crm.description')"
                                            required
                                            outlined
                                            :disabled="isDisabled(this.payloadGoods.id)"
                                            counter="200"
                                    ></v-textarea>
                                </v-col>
                                <v-col class="pb-0" cols="12">
                                    <v-text-field
                                            v-model="payloadGoods.marks"
                                            :label="$t('crm.marks')"
                                            outlined
                                            :disabled="isDisabled(this.payloadGoods.id)"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="pb-0" cols="12">
                                    <v-text-field
                                        v-model="payloadGoods.packagesNumber"
                                        :rules="[rules.decimal]"
                                        :label="$t('crm.packages_number')"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col class="pb-0" cols="12">
                                    <v-text-field
                                        v-model="payloadGoods.packingMethod"
                                        :label="$t('crm.packing_method')"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col class="pb-0" cols="12">
                                    <v-text-field
                                        v-model="payloadGoods.statisticNumber"
                                        :label="$t('crm.statistic_number')"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col class="pb-0" cols="12">
                                    <v-text-field
                                        v-model="payloadGoods.grossWeight"
                                        :rules="[rules.decimal]"
                                        :label="$t('crm.gross_weight')"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col class="pb-0" cols="12">
                                    <v-text-field
                                        v-model="payloadGoods.volume"
                                        :rules="[rules.decimal]"
                                        :label="$t('crm.volume')"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col v-if="editCrmId" class="pb-0" cols="12">
                                    <v-text-field
                                        v-model="payloadGoods.code"
                                        :label="$t('crm.tbl_code')"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn right text color="primary" @click="() => closeDialog()">
                        {{ $t('cancel') }}
                    </v-btn>
                    <v-btn right text color="primary" @click="saveGoods">
                        {{ $t('apply') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-if="tableType==='containers'" v-model="dialogTableContainers" max-width="600px">
            <v-card>
                <v-card-title class="headline lighten-2" primary-title>
                    {{ formTitleContainers }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-form ref="formContainers" v-model="formContainersValid" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col class="pb-0" cols="12">
                                    <v-text-field
                                        v-model="payloadContainers.number"
                                        :label="$t('crm.containersNumber')"
                                        outlined
                                        :disabled="isDisabled(this.payloadContainers.id)"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="pb-0" cols="12">
                                    <v-text-field
                                        v-model="payloadContainers.sealNumber"
                                        :label="$t('crm.containersSealNumber')"
                                        outlined
                                        :disabled="isDisabled(this.payloadContainers.id)"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="pb-0" cols="12">
                                    <v-text-field
                                        v-model="payloadContainers.type"
                                        :label="$t('crm.containersType')"
                                        outlined
                                        :disabled="isDisabled(this.payloadContainers.id)"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="pb-0" cols="12">
                                    <v-text-field
                                        v-model="payloadContainers.containerOwner"
                                        :label="$t('crm.containersOwner')"
                                        outlined
                                        :disabled="isDisabled(this.payloadContainers.id)"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="pb-0" cols="12">
                                    <v-text-field
                                        v-model="payloadContainers.taraWeight"
                                        :label="$t('crm.containersWeight')"
                                        outlined
                                        :rules="[rules.decimal]"
                                        :disabled="isDisabled(this.payloadContainers.id)"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn right text color="primary" @click="() => closeDialog()">
                        {{ $t('cancel') }}
                    </v-btn>
                    <v-btn right text color="primary" @click="saveContainers">
                        {{ $t('apply') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import config from '../../config'
    import Axios from 'axios'

    const qs = require('querystring')

    export default {
        components: {},
        name: "OrdersEditModalTables",
        props: ['editCrmId', 'tableType', 'dialog', 'dialogGoods', 'dialogContainers', 'dialogName', 'closeDialogTable', 'openDialogTable', 'isReadOnly', 'cmrStatus'],
        data() {
            return {
                headers: {
                    goods: [
                        {text: this.$i18n.t('crm.tbl_code'), value: 'code', width: '1%', align: 'left', sortable: false},
                        {text: this.$i18n.t('crm.goods_nature'), value: 'goodsNature', width: '1%', align: 'left'},
                        {text: this.$i18n.t('crm.gross_weight'), value: 'grossWeight', width: '1%', align: 'left'},
                        {text: this.$i18n.t('crm.marks'), value: 'marks', width: '1%', align: 'left'},
                        {text: this.$i18n.t('crm.packages_number'), value: 'packagesNumber', width: '1%', align: 'left'},
                        {text: this.$i18n.t('crm.packing_method'), value: 'packingMethod', width: '1%', align: 'left'},
                        {text: this.$i18n.t('crm.statistic_number'), value: 'statisticNumber', width: '1%', align: 'left'},
                        {text: this.$i18n.t('crm.volume'), value: 'volume', width: '1%', align: 'left'},
                        {text: this.$i18n.t('crm.approved'), value: 'approved', width: '1%', align: 'left', sortable: false},
                        {text: '', value: 'edit', width: '1%', align: 'left', sortable: false},
                        {text: '', value: 'delete', width: '1%', align: 'left', sortable: false},
                    ],
                    containers: [
                        {text: this.$i18n.t('crm.number'), value: 'number', width: '1%', align: 'left'},
                        {text: this.$i18n.t('crm.seal_number'), value: 'sealNumber', width: '1%', align: 'left'},
                        {text: this.$i18n.t('crm.approved'), value: 'approved', width: '1%', align: 'left', sortable: false},
                        {text: '', value: 'edit', width: '1%', align: 'left', sortable: false},
                        {text: '', value: 'delete', width: '1%', align: 'left', sortable: false},
                    ],
                    pallets: [
                        {text: this.$i18n.t('crm.description'), value: 'typeCodeDescription', width: '1%', align: 'left'},
                        {text: this.$i18n.t('crm.unitWeight'), value: 'unitWeight', width: '1%', align: 'left', sortable: false},
                        {text: this.$i18n.t('crm.loadingPlaceUnloaded'), value: 'loadingPlaceUnloaded', width: '1%', align: 'left', sortable: false},
                        {text: this.$i18n.t('crm.loadingPlaceLoaded'), value: 'loadingPlaceLoaded', width: '1%', align: 'left'},
                        {text: this.$i18n.t('crm.unloadingPlaceUnloaded'), value: 'unloadingPlaceUnloaded', width: '1%', align: 'left', sortable: false},
                        {text: this.$i18n.t('crm.unloadingPlaceLoaded'), value: 'unloadingPlaceLoaded', width: '1%', align: 'left', sortable: false},
                        {text: '', value: 'edit', width: '1%', align: 'left', sortable: false},
                        {text: '', value: 'delete', width: '1%', align: 'left', sortable: false},
                    ],
                },

                listItem: [],
                options: {
                    rowsPerPageItems: 10,
                    page: 1,
                    itemsPerPage: 10,
                },
                total: 0,
                formPalletsValid: false,
                formGoodsValid: false,
                formContainersValid: false,
                payloadPallets: {
                    id: null,
                    typeCodeDescription: '',
                    loadingPlaceLoaded: '',
                    loadingPlaceUnloaded: '',
                    unloadingPlaceLoaded: '',
                    unloadingPlaceUnloaded: '',
                    unitWeight: '',
                },
                payloadPalletsDefault: {
                    id: null,
                    typeCodeDescription: '',
                    loadingPlaceLoaded: '',
                    loadingPlaceUnloaded: '',
                    unloadingPlaceLoaded: '',
                    unloadingPlaceUnloaded: '',
                    unitWeight: '',
                },

                payloadGoods: {
                },
                payloadGoodsDefault: {
                    id: null,
                    goodsNature: '',
                    marks: '',
                    packagesNumber: '',
                    packingMethod: '',
                    statisticNumber: '',
                    grossWeight: '',
                    volume: '',
                    code: '',
                    type: '1',
                },

                payloadContainers: {},
                payloadContainersDefault: {
                    id: null,
                    number: '',
                    sealNumber: '',
                    type: '',
                    containerOwner: '',
                    taraWeight: ''
                },

                rules: {
                    required: value => !!value || this.$i18n.t('field_is_required'),
                    number: value => {
                        const pattern = /^\d+$/
                        return value === null || value === '' || pattern.test(value) || this.$i18n.t('field_is_not_number')
                    },
                    decimal: value => {
                        const pattern = /^[0-9]*[.,]?[0-9]+$/
                        return value === null || value === '' || pattern.test(value) || this.$i18n.t('field_is_not_number')
                    },
                    length: len => v => v.length <= len || this.$i18n.t('fieldWrongLength'),
                },

            }
        },
        computed: {
            getHeaders() {
                switch (this.tableType) {
                    case 'containers':
                        return  this.headers.containers;
                    case 'goods':
                    case 'returnedGoods':
                        return  this.headers.goods;
                    case 'pallets':
                        return this.isReadOnly ? [...this.headers.pallets].splice(0, 5) : this.headers.pallets;
                    default:
                        return ''
                }

            },

            formTitlePallets() {
                return this.payloadPallets.id ? this.$i18n.t('crm.editPallets') : this.$i18n.t('crm.addPallets')
            },

            formTitleGoods() {
              return this.payloadGoods.id ? this.$i18n.t('crm.editGoods') : this.$i18n.t('crm.addGoods')
            },

            formTitleContainers() {
              return this.payloadContainers.id ? this.$i18n.t('crm.editContainers') : this.$i18n.t('crm.addContainers')
            },

            dialogTable: {
                get(){
                    return this.dialog
                },
                set() {
                    this.closeDialog()
                }
            },
            dialogTableGoods: {
                get(){
                    return this.dialogGoods
                },
                set() {
                    this.closeDialog()
                }
            },
            dialogTableContainers: {
                get(){
                    return this.dialogContainers
                },
                set() {
                    this.closeDialog()
                }
            }

        },
        watch: {
            editCrmId() {
                this.getGoodList(this.getData())
            },
            'options.page'() {
                this.getGoodList(this.getData())
            },
            'options.itemsPerPage'() {
                this.getGoodList(this.getData())
            }

        },
        methods: {
            getGoodList(data) {
                let url = '';
                switch (this.tableType) {
                    case 'containers': {
                        url = 'api/container/list';
                        break;
                    }
                    case 'goods':
                    case 'returnedGoods': {
                        url = 'api/good/list';
                        break;
                    }
                    case 'pallets': {
                        url = 'api/pallet/list';
                        break;
                    }
                }
                Axios.post(config.apiBaseUrl + url, qs.stringify(data), {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }
                )
                    .then( ({data, status}) => {
                        if (status === 200) {
                            this.listItem = data.data.map( el => {
                                if(el['grossWeight']) {
                                    el['grossWeight'] = parseFloat(el['grossWeight']).toLocaleString('de')
                                }
                                if(el['volume']) {
                                    el['volume'] = parseFloat(el['volume']).toLocaleString('de')
                                }
                                if(el['packagesNumber']) {
                                    el['packagesNumber'] = parseFloat(el['packagesNumber']).toLocaleString('de')
                                }
                                return el;
                            });
                            this.total = data.total;

                        }
                    })
                    .catch(function (error) {
                        /* eslint-disable */
                        console.error(error.response.data)
                        alert(error.response.data )
                    })
            },

            getData() {
                let data = {}
                data.cmrID = this.editCrmId
                data.Page = this.options.page
                data.Limit = this.options.itemsPerPage
                data.goodType = this.tableType === 'goods' ? 1 : 2

                return data;
            },

            updateTable() {
                this.getGoodList(this.getData())
            },

            editItem(item) {
                switch (this.tableType) {
                    case 'containers':
                        this.payloadContainers = {...item};
                        break;
                    case 'goods':
                        this.payloadGoods = {...item};
                        break;
                    case 'returnedGoods':
                    case 'pallets':
                        this.payloadPallets = {...item};
                        break;
                    default:
                        this.payloadPallets = {...this.payloadPalletsDefault};
                        this.payloadGoods = {...this.payloadGoodsDefault};
                        this.payloadContainers = {...this.payloadContainersDefault};
                }
                this.openDialogTable();
            },

            deleteItem(id) {
                let confirmText = '', tabType = this.tableType;
                switch (this.tableType) {
                    case 'containers':
                        tabType = 'container';
                        confirmText = this.$i18n.t('crm.orderDeleteContainer');
                        break;
                    case 'goods':
                        tabType = 'good';
                        confirmText = this.$i18n.t('crm.orderDeleteGoods');
                        break;
                    case 'returnedGoods':
                    case 'pallets':
                        tabType = 'pallet';
                        confirmText = this.$i18n.t('crm.orderDeletePallet');
                        break;
                }
                if(confirm(confirmText)) {
                    Axios.get(config.apiBaseUrl + `api/${tabType}/delete?id=${id}`, {
                            headers: {
                                'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        }
                    )
                        .then(response => {
                            if (response.status === 200) {
                                this.updateTable();
                            }
                        })
                        .catch(function (error) {
                            /* eslint-disable */
                            console.error(error.response.data)
                            alert(error.response.data )
                        })
                }
            },

            savePallet() {
                if (this.$refs.formPallets.validate()) {
                    let url = config.apiBaseUrl;
                    if(this.payloadPallets.id) {
                        url += 'api/pallet/edit'
                    } else {
                        url += 'api/pallet/create'
                    }

                    let data = {...this.payloadPallets};
                    data.cmrId = this.editCrmId;

                    Axios.post(url , qs.stringify(data), {
                            headers: {
                                'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        }
                    )
                        .then( response => {
                            if (response.status === 200) {
                                this.closeDialog();
                                this.updateTable();
                            }
                        })
                        .catch(function (error) {
                            /* eslint-disable */
                            console.error(error.response.data)
                            alert(error.response.data )
                        })
                }

            },

            saveGoods() {
                if (this.$refs.formGoods.validate()) {
                    let url = config.apiBaseUrl;
                    if(this.payloadGoods.id) {
                        url += 'api/good/edit'
                    } else {
                        url += 'api/good/create'
                    }

                    let data = {...this.payloadGoods};
                    data.cmrId = this.editCrmId;

                    Axios.post(url , qs.stringify(data), {
                          headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                            'Content-Type': 'application/x-www-form-urlencoded'
                          }
                        }
                    )
                        .then( response => {
                            if (response.status === 200) {
                                this.closeDialog();
                                this.updateTable();
                            }
                        })
                        .catch(function (error) {
                            /* eslint-disable */
                            console.error(error.response.data)
                            alert(error.response.data )
                        })
                }
            },

            saveContainers() {
                if (this.$refs.formContainers.validate()) {
                    let url = config.apiBaseUrl;
                    if(this.payloadContainers.id) {
                        url += 'api/container/edit'
                    } else {
                        url += 'api/container/create'
                    }

                    let data = {...this.payloadContainers};
                    data.cmrId = this.editCrmId;

                    Axios.post(url , qs.stringify(data), {
                          headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                            'Content-Type': 'application/x-www-form-urlencoded'
                          }
                        }
                    )
                        .then( response => {
                            if (response.status === 200) {
                                this.closeDialog();
                                this.updateTable();
                            }
                        })
                        .catch(function (error) {
                            /* eslint-disable */
                            console.error(error.response.data)
                            alert(error.response.data )
                        })
                }
            },

            closeDialog() {
                this.closeDialogTable();
                this.payloadPallets = {...this.payloadPalletsDefault};
                this.payloadGoods = {...this.payloadGoodsDefault};
                this.payloadContainers = {...this.payloadContainersDefault};
            },

            isDisabled(id) {
                if(id) {
                    return this.cmrStatus === 3 || this.cmrStatus === 4
                } else {
                    return false;
                }
            },

            isDisabledByStatus() {
                return this.cmrStatus === 3 || this.cmrStatus === 4
            }

            // -----end methods
        },
        created() {
            this.getGoodList(this.getData());
            this.payloadPallets.id = null;
            this.payloadGoods = {...this.payloadGoodsDefault};
            this.payloadContainers = {...this.payloadContainersDefault};
        },
    }
</script>
